module.exports = __webpack_public_path__ + "static/img/BackgroundOfMultimodalTransportCollaboration.2114247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-v2/BackgroundOfMultimodalTransportCollaboration.png
// module id = knAt
// module chunks = 44